import { MultipleComplexValidator } from './multiple-complex.validator';

export class MultipleComplexTextInputMaxLengthValidator implements MultipleComplexValidator {
  public errorKey = 'dynamicMaxLength';
  public value = '';

  constructor(private maxLength: number) {}

  get isValid(): boolean {
    return this.value.length <= this.maxLength;
  }
}
